// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1dfc0900","312":"6f6b6944","453":"e983c978"}[chunkId] + ".chunk.js";
};